import { render } from "./total-table.vue?vue&type=template&id=1f44ee3c&scoped=true"
import script from "./total-table.vue?vue&type=script&lang=js"
export * from "./total-table.vue?vue&type=script&lang=js"

import "./total-table.vue?vue&type=style&index=0&id=1f44ee3c&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f44ee3c"]])

export default __exports__